// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2ZQbl","inputWrap":"Table_inputWrap__2acyW","col":"Table_col__bIlJZ","bmiTooltip":"Table_bmiTooltip__1UDI8"};